import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'how_are_complaints_and_grievances_settled_select_all_that_apply'

export const dataPointDefinition = {
  retracedId: 'how_are_complaints_and_grievances_settled_select_all_that_apply',
  name: 'How are complaints and grievances settled?',
  description:
    'If there is no example of a complaint or grievance, i.e. there has been no complaint or grievance in the last months within this assessment period, but you have a policy/ procedure in place around settling complaints or grievances, please select all that apply in accordance with your policy/procedure.',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'SETTLED_DIRECTLY_BETWEEN_THE_WORKER_AND_THEIR_IMMEDIATE_SUPERVI',
      text: 'Settled directly between the worker and their immediate supervisor',
      externalIds: [
        {
          id: 'gr-3-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'SETTLED_WITH_THE_ASSISTANCE_OF_ADDITIONAL_STAKEHOLDERS_DEPARTME',
      text: 'Settled with the assistance of additional stakeholders/departments (i.e. the Human Resources (HR) department, Unions, Worker Representative, etc.)',
      externalIds: [
        {
          id: 'gr-3-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe which stakeholders/departments assist with the settlement:',
        externalIds: [
          {
            id: 'gr-3-2f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'THERE_ARE_OPTIONS_FOR_SENIOR_MANAGEMENT_REVIEW_IF_DIRECT_SETTLE',
      text: 'There are options for senior management review if direct settlement with the supervisor or additional stakeholders/departments has failed',
      externalIds: [
        {
          id: 'gr-3-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKERS_HAVE_THE_RIGHT_TO_RESPOND_TO_AND_OR_APPEAL_THE_SETTLEME',
      text: 'Workers have the right to respond to and/or appeal the settlement',
      externalIds: [
        {
          id: 'gr-3-4x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'gr-3-5x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'NUMBER',
        text: 'If yes, how many complaints and grievances were received by female workers?',
        externalIds: [
          {
            id: 'wi-gri-9',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'SETTLED_DIRECTLY_BETWEEN_THE_WORKER_AND_THEIR_IMMEDIATE_SUPERVI',
                'SETTLED_WITH_THE_ASSISTANCE_OF_ADDITIONAL_STAKEHOLDERS_DEPARTME',
                'THERE_ARE_OPTIONS_FOR_SENIOR_MANAGEMENT_REVIEW_IF_DIRECT_SETTLE',
                'WORKERS_HAVE_THE_RIGHT_TO_RESPOND_TO_AND_OR_APPEAL_THE_SETTLEME',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wi-gri-7',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 13080,
  sectionId: '2.2.10',
  impactArea: 'Social Dialogue, Grievance Mechanisms and Disputes',
  impactAreaId: 'COMPLAINT_AND_GRIEVANCE_SYSTEMS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
